import type { Patient } from "fhir/r5";

export function isPatientResource(resource: unknown): resource is Patient {
  return (
    typeof resource === "object" &&
    resource !== null &&
    "resourceType" in resource &&
    resource.resourceType === "Patient"
  );
}
